module.exports = __webpack_public_path__ + "static/media/angle-arrow-up-primary.f5b11ebd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/angle-arrow-up-primary.svg
// module id = 544
// module chunks = 0